/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'maison': {
    width: 15.728,
    height: 15,
    viewBox: '0 0 15.728 15',
    data: '<path pid="0" data-name="Tracé 81" d="M15.578 5.432L8.068.063a.361.361 0 0 0-.409 0L.149 5.432a.335.335 0 0 0-.127.395.351.351 0 0 0 .338.24h1.79v8.583a.349.349 0 0 0 .352.352h10.723a.349.349 0 0 0 .352-.352V6.066h1.79a.351.351 0 0 0 .338-.24.329.329 0 0 0-.127-.394zm-9 8.863V9.237h2.913v5.059zm6.647-8.933a.349.349 0 0 0-.352.352v8.581h-2.677V8.884a.349.349 0 0 0-.352-.352H6.222a.349.349 0 0 0-.352.352v5.411H2.84V5.714a.349.349 0 0 0-.352-.352H1.445l6.41-4.58 6.411 4.58z" _fill="#766e6a"/>'
  }
})
